<script setup>
import { computed } from 'vue';
import { frontendURL } from 'dashboard/helper/URLHelper';

import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

const props = defineProps({
  id: {
    type: [String, Number],
    default: 0,
  },
  email: {
    type: String,
    default: '',
  },
  phone: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  thumbnail: {
    type: String,
    default: '',
  },
  accountId: {
    type: [String, Number],
    default: 0,
  },
  usernameBo: {
    type: String,
    default: '',
  },
});

const navigateTo = computed(() => {
  return frontendURL(`accounts/${props.accountId}/contacts/${props.id}`);
});
</script>

<template>
  <router-link :to="navigateTo" class="contact-item">
    <Avatar
      :name="name"
      :src="thumbnail"
      :size="32"
      rounded-full
      class="contact-item__avatar"
    />
    <div class="contact-item__body">
      <h5>{{ name }}</h5>
      <p>
        <span v-if="email" :title="email">{{ email }}</span>
        <span v-if="phone" class="sep">•</span>
        <span v-if="phone">{{ phone }}</span>
        <span v-if="usernameBo" class="sep">•</span>
        <span v-if="usernameBo">BO: {{ usernameBo }}</span>
      </p>
    </div>
  </router-link>
</template>

<style scoped>
.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 12px;
  color: inherit;
  text-decoration: none;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
}

.contact-item:hover {
  border-color: var(--wlab-border-light, var(--n-weak));
  background: color-mix(in srgb, var(--wlab-accent, #6366f1) 6%, transparent);
}

.contact-item__avatar {
  margin-top: 2px;
}

.contact-item__body {
  min-width: 0;
}

.contact-item__body h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--wlab-text-primary, var(--n-slate-12));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contact-item__body p {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--wlab-text-secondary, var(--n-slate-12));
}

.contact-item__body .sep {
  color: var(--wlab-text-muted, var(--n-slate-10));
}
</style>
